<li id="org-nav">
    <div class="dropdown">
        <button
            class="btn btn-default dropdown-toggle"
            type="button"
            id="current-org-btn"
            data-bs-toggle="dropdown">
            <span class="me-1 fa fa-building"></span>
            <span id="menu-org-name">
                {{ organizationName() }}
            </span>
            <span class="caret more-dropdown"></span>
        </button>
        <ul
            #orgToggleDropdown
            class="dropdown-menu">
            <li
                class="form-group"
                style="margin-bottom: 0">
                <input
                    #orgToggleSearch
                    class="form-control"
                    type="text"
                    placeholder="Search..."
                    [(ngModel)]="search" />
            </li>
            @for (org of filteredOrganizations(); track org.id) {
                <li [class.disabled]="org.isDisabled">
                    <a
                        kno2NoOpLink
                        (click)="changeOrganization(org)">
                        {{ org.name }}
                        @if (org.switchMode === "signIn") {
                            <i
                                class="pi pi-unlock ms-1"
                                title="Requires signing in again"
                                data-bs-toggle="tooltip"></i>
                        }
                    </a>
                </li>
            }
        </ul>
    </div>
</li>
